import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container-fluid p-4" };
const _hoisted_2 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_3 = { class: "card-body" };
const _hoisted_4 = { class: "row g-3" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = { class: "col-md-6" };
const _hoisted_7 = ["value"];
const _hoisted_8 = {
    key: 0,
    class: "card border-0 shadow-sm mb-3"
};
const _hoisted_9 = { class: "card-body" };
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" };
const _hoisted_11 = { class: "mb-1" };
const _hoisted_12 = { class: "text-muted mb-0" };
const _hoisted_13 = { class: "row g-3 mb-3" };
const _hoisted_14 = { class: "col-md-8" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "col-md-4 d-flex align-items-end" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_19 = {
    key: 0,
    class: "alert alert-success py-2"
};
const _hoisted_20 = {
    key: 1,
    class: "alert alert-danger py-2"
};
const _hoisted_21 = { class: "table-responsive" };
const _hoisted_22 = { class: "table table-hover align-middle" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { class: "text-muted small" };
const _hoisted_26 = { class: "text-end" };
const _hoisted_27 = ["disabled", "onClick"];
const _hoisted_28 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_29 = {
    key: 1,
    class: "fas fa-unlink me-1"
};
import { computed, onMounted, ref, watch } from 'vue';
import adminArticlesService from '@/services/admin/articles.admin.service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminArticleRelations',
    setup(__props) {
        const articles = ref([]);
        const loadingArticles = ref(false);
        const selectedParentId = ref('');
        const selectedChildId = ref('');
        const parentSearch = ref('');
        const childArticles = ref([]);
        const loadingChildren = ref(false);
        const savingChild = ref(false);
        const removingChildId = ref(null);
        const childSuccessMessage = ref('');
        const childErrorMessage = ref('');
        const filteredParentOptions = computed(() => {
            const search = parentSearch.value.toLowerCase().trim();
            if (!search)
                return articles.value;
            return articles.value.filter(article => (article.title || '').toLowerCase().includes(search));
        });
        const selectedParent = computed(() => articles.value.find(article => String(article.id) === selectedParentId.value) || null);
        const availableChildren = computed(() => {
            if (!selectedParent.value)
                return [];
            const childIds = new Set(childArticles.value.map(child => child.id));
            return articles.value.filter(article => {
                if (article.id === selectedParent.value.id)
                    return false;
                if (childIds.has(article.id))
                    return false;
                return article.parent_id == null || article.parent_id === 0;
            });
        });
        function formatDate(date) {
            if (!date)
                return '—';
            try {
                return new Date(date).toLocaleDateString();
            }
            catch {
                return date;
            }
        }
        async function loadArticles() {
            loadingArticles.value = true;
            try {
                const res = await adminArticlesService.list({ limit: 9999 });
                if (Array.isArray(res.data)) {
                    articles.value = res.data;
                }
                else if (res.success && Array.isArray(res.data)) {
                    articles.value = res.data;
                }
                else {
                    articles.value = [];
                }
            }
            catch (error) {
                console.error('Error cargando artículos', error);
                articles.value = [];
            }
            finally {
                loadingArticles.value = false;
            }
        }
        async function loadChildren(parentId) {
            loadingChildren.value = true;
            childErrorMessage.value = '';
            try {
                const res = await adminArticlesService.listByParent(parentId);
                if (res && res.success && Array.isArray(res.data)) {
                    childArticles.value = res.data;
                }
                else if (Array.isArray(res.data)) {
                    childArticles.value = res.data;
                }
                else if (Array.isArray(res)) {
                    childArticles.value = res;
                }
                else {
                    childArticles.value = [];
                }
            }
            catch (error) {
                childErrorMessage.value = error?.response?.data?.message || error?.message || 'No se pudieron cargar los artículos hijos';
                childArticles.value = [];
            }
            finally {
                loadingChildren.value = false;
            }
        }
        async function addChild() {
            if (!selectedParent.value || !selectedChildId.value)
                return;
            savingChild.value = true;
            childSuccessMessage.value = '';
            childErrorMessage.value = '';
            try {
                await adminArticlesService.update(Number(selectedChildId.value), { parent_id: Number(selectedParent.value.id) });
                childSuccessMessage.value = 'Artículo hijo agregado correctamente.';
                selectedChildId.value = '';
                await loadChildren(selectedParent.value.id);
            }
            catch (error) {
                childErrorMessage.value = error?.response?.data?.message || error?.message || 'No se pudo agregar el artículo hijo';
            }
            finally {
                savingChild.value = false;
                setTimeout(() => (childSuccessMessage.value = ''), 3500);
            }
        }
        async function detachChild(child) {
            if (!selectedParent.value)
                return;
            if (!confirm('¿Quitar este artículo hijo?'))
                return;
            removingChildId.value = child.id;
            childErrorMessage.value = '';
            try {
                await adminArticlesService.update(child.id, { parent_id: null });
                await loadChildren(selectedParent.value.id);
            }
            catch (error) {
                childErrorMessage.value = error?.response?.data?.message || error?.message || 'No se pudo quitar el artículo hijo';
            }
            finally {
                removingChildId.value = null;
            }
        }
        watch(selectedParentId, (newVal) => {
            childArticles.value = [];
            selectedChildId.value = '';
            childSuccessMessage.value = '';
            childErrorMessage.value = '';
            if (newVal) {
                loadChildren(newVal);
            }
        });
        onMounted(loadArticles);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2" }, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h1", { class: "h3 mb-1" }, [
                            _createElementVNode("i", { class: "fas fa-project-diagram text-primary me-2" }),
                            _createTextVNode(" Relaciones entre Artículos ")
                        ]),
                        _createElementVNode("p", { class: "text-muted mb-0" }, "Configura qué artículos actúan como padres y cuáles se muestran como hijos.")
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-label" }, "Buscar artículo padre", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    placeholder: "Filtra por título...",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((parentSearch).value = $event))
                                }, null, 512), [
                                    [_vModelText, parentSearch.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "Selecciona el artículo padre", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedParentId).value = $event))
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "-- Selecciona un artículo --", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredParentOptions.value, (article) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: article.id,
                                            value: String(article.id)
                                        }, _toDisplayString(article.title || `Artículo #${article.id}`), 9, _hoisted_7));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, selectedParentId.value]
                                ])
                            ])
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted d-block mt-2" }, [
                            _createTextVNode(" Los hijos se cargan automáticamente desde "),
                            _createElementVNode("code", null, "/api/articles/by-parent/{id}"),
                            _createTextVNode(". ")
                        ], -1))
                    ])
                ]),
                (selectedParent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("h5", _hoisted_11, _toDisplayString(selectedParent.value.title || `Artículo #${selectedParent.value.id}`), 1),
                                    _createElementVNode("p", _hoisted_12, "ID: " + _toDisplayString(selectedParent.value.id) + " | Sección: " + _toDisplayString(selectedParent.value.page_section || 'N/A'), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Agregar artículo hijo", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedChildId).value = $event))
                                    }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "-- Selecciona un artículo --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableChildren.value, (article) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: article.id,
                                                value: String(article.id)
                                            }, _toDisplayString(article.title || `Artículo #${article.id}`), 9, _hoisted_15));
                                        }), 128))
                                    ], 512), [
                                        [_vModelSelect, selectedChildId.value]
                                    ]),
                                    _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-muted" }, "Solo se muestran artículos que no son el padre ni ya están asociados como hijos.", -1))
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary w-100",
                                        disabled: !selectedChildId.value || savingChild.value,
                                        onClick: addChild
                                    }, [
                                        (savingChild.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(savingChild.value ? 'Guardando...' : 'Agregar hijo'), 1)
                                    ], 8, _hoisted_17)
                                ])
                            ]),
                            (childSuccessMessage.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(childSuccessMessage.value), 1))
                                : _createCommentVNode("", true),
                            (childErrorMessage.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(childErrorMessage.value), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("table", _hoisted_22, [
                                    _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "Título"),
                                            _createElementVNode("th", null, "Sección"),
                                            _createElementVNode("th", null, "Fecha"),
                                            _createElementVNode("th", {
                                                class: "text-end",
                                                style: { "width": "140px" }
                                            }, "Acciones")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (loadingChildren.value)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[10] || (_cache[10] = [
                                                    _createElementVNode("td", {
                                                        colspan: "4",
                                                        class: "text-center p-4"
                                                    }, [
                                                        _createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }),
                                                        _createElementVNode("span", { class: "ms-2" }, "Cargando hijos…")
                                                    ], -1)
                                                ]))]))
                                            : (childArticles.value.length === 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[11] || (_cache[11] = [
                                                        _createElementVNode("td", {
                                                            colspan: "4",
                                                            class: "text-center p-4 text-muted"
                                                        }, [
                                                            _createElementVNode("i", { class: "fas fa-layer-group fa-2x d-block mb-2" }),
                                                            _createTextVNode(" Este artículo todavía no tiene hijos asociados. ")
                                                        ], -1)
                                                    ]))]))
                                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(childArticles.value, (child) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: child.id
                                                    }, [
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("strong", null, _toDisplayString(child.title || `Artículo #${child.id}`), 1),
                                                            _createElementVNode("div", _hoisted_25, "ID: " + _toDisplayString(child.id), 1)
                                                        ]),
                                                        _createElementVNode("td", null, _toDisplayString(child.page_section || 'N/A'), 1),
                                                        _createElementVNode("td", null, _toDisplayString(formatDate(child.created_at)), 1),
                                                        _createElementVNode("td", _hoisted_26, [
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-danger",
                                                                disabled: removingChildId.value === child.id,
                                                                onClick: ($event) => (detachChild(child))
                                                            }, [
                                                                (removingChildId.value === child.id)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                                                                    : (_openBlock(), _createElementBlock("i", _hoisted_29)),
                                                                _cache[12] || (_cache[12] = _createTextVNode(" Quitar ", -1))
                                                            ], 8, _hoisted_27)
                                                        ])
                                                    ]));
                                                }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
